import { format, isSameDay, parseISO, subDays } from "date-fns";

import { isFilterSet } from "../../utils/filters";
import { DepositFilterValues, DepositListParams } from "./types";

export const DEPOSITS_PAGE_SIZE = 10;

// Newest deposits first ("Showing latest deposits collected first").
export const DEPOSITS_DEFAULT_ORDERING = "-backend_creation_time";

export const DEFAULT_DEPOSIT_FILTERS: DepositFilterValues = {
  commodity_id: "",
  quality: "",
  aggregator_id: "",
  location_id: "",
};

export const buildDepositParams = (
  filters: DepositFilterValues,
  page: number
): DepositListParams => ({
  page_size: DEPOSITS_PAGE_SIZE,
  page,
  ordering: DEPOSITS_DEFAULT_ORDERING,
  deleted: false,
  is_sold: false,
  exclude_direct_offer_same_trader: true,
  with_location: true,
  ...(isFilterSet(filters.commodity_id) ? { commodity_id: filters.commodity_id } : {}),
  ...(isFilterSet(filters.quality) ? { quality: filters.quality } : {}),
  ...(isFilterSet(filters.aggregator_id) ? { aggregator_id: filters.aggregator_id } : {}),
  ...(isFilterSet(filters.location_id) ? { location_id: filters.location_id } : {}),
});

// `now` is injectable for testing; defaults to the real current time.
export const formatDepositDate = (
  date: string,
  labels: { today: string; yesterday: string },
  now: Date = new Date()
): string => {
  const depositDate = parseISO(date);
  const time = format(depositDate, "HH:mm");

  if (isSameDay(depositDate, now)) {
    return `${labels.today} - ${time}`;
  }

  if (isSameDay(depositDate, subDays(now, 1))) {
    return `${labels.yesterday} - ${time}`;
  }

  return format(depositDate, "d MMM yyyy, HH:mm");
};
